<!-- ══════════════════════════════════════════════════════════════════════════════════════
     FENÊTRE « PROGRAMMATION DE LIVRAISON »
     Le document plutôt que l'application : aucune carte, aucune ombre, aucun aplat. La
     hiérarchie ne tient qu'à la typographie et à des filets de 1 px sur du blanc.

     DEUX COLONNES, DU HAUT EN BAS DE LA FEUILLE, ET PAS DE PIED.
       à gauche  — le tableau des lignes, les onglets de livraison, la planification et sa
                   consigne, puis l'ajout de pièce jointe ;
       à droite  — la carte en 16/9 à fond perdu, puis les documents du bon, dans un MÊME
                   défilement.
     Aucun intitulé de section décoratif : le contenu se nomme tout seul, et chaque ligne
     rendue au tableau est une ligne de plus visible sans défiler.
     ══════════════════════════════════════════════════════════════════════════════════════ -->
@if (!isDialog) {
<app-menu-common url="sales"></app-menu-common>
}

@if (formGroup && order && order.id) {
<div class="dlg">

	<!-- ═══ EN-TÊTE ══════════════════════════════════════════════════════════════════════
	     Une seule ligne : les trois faits à gauche, les trois actions à droite contre la croix ; aucune des trois ne ferme la fenêtre. -->
	<header class="mast">
		<div class="mast-facts">
			<div class="fact">
				<span class="lbl">Référence</span>
				<span class="docref"><i>N°</i>{{ id }}</span>
			</div>
			<div class="fact">
				<span class="lbl">Client@if (isDistinctBeneficiary) { <i class="badge-role">(tiers payeur)</i>}</span>
				<span class="val strong">{{ customer_label }}</span>
			</div>
			<div class="fact">
				<span class="lbl">Adresse de livraison@if (isDistinctBeneficiary) { <i class="badge-role">(bénéficiaire{{ beneficiary_label ? ' ' + beneficiary_label : '' }})</i>}</span>
				<span class="val">{{ adr_delivery }}</span>
			</div>
		</div>
		<span class="grow"></span>
		<div class="mast-acts">
			<button type="button" class="btn" id="validatedeliverybutton"
				[disabled]="isDelivered(activeDelivery)" (click)="confirmTakeAway()"
				aria-label="Livrer maintenant les produits"><mat-icon>fact_check</mat-icon>Livrer maintenant les produits</button>
			<button type="button" class="btn blue" id="printdeliverybutton" (click)="onPrintDelivery()"
				[attr.aria-label]="isDelivered(activeDelivery) ? 'Imprimer le BL signé' : 'Planifier + imprimer le BL'">
				<mat-icon>print</mat-icon>{{ isDelivered(activeDelivery) ? 'Imprimer le BL signé' : 'Planifier + imprimer le BL' }}</button>
			<button type="button" class="btn green" id="plandeliverybutton"
				[disabled]="isDelivered(activeDelivery)" (click)="onPlanDelivery()"
				aria-label="Planifier la livraison"><mat-icon>event_available</mat-icon>Planifier la livraison</button>
		</div>
		@if (isDialog) {
		<button class="icon-btn danger" type="button" (click)="closeDialog()"
			matTooltip="Fermer" aria-label="Fermer">
			<mat-icon>close</mat-icon>
		</button>
		}
	</header>

	<div class="body">

		<!-- ═══ COLONNE DE GAUCHE — LA COMMANDE ET SA LIVRAISON ══════════════════════════ -->
		<section class="col-lines">

			<!-- Le bandeau de verrouillage n'est plus un bandeau : une mention sur un filet. -->
			@if (activeDelivery && isDelivered(activeDelivery)) {
				<div class="locked">
					<mat-icon>lock</mat-icon>
					<span>@if (isCancel(activeDelivery)) { Bon d'annulation du reste à livrer, posé le } @else { Livraison {{ delivery_index + 1 }} validée le }
						<strong>{{ activeDelivery.realdatdel | tzdate: 'DD/MM/YYYY' }}</strong> à
						<strong>{{ activeDelivery.realdatdel | tzdate: 'HH:mm' }}</strong> — @if (isCancel(activeDelivery)) { quantités soldées, jamais livrées } @else { quantités non modifiables }@if (remainingQty === 0 && allDeliveriesSigned) { — commande {{ hasCancel ? 'soldée' : 'entièrement livrée' }} }</span>
				</div>
			}

			<div class="scroll-y grow">
				<!-- Le nombre de colonnes dépend du nombre de livraisons : la grille se pose en liaison.
				     Le code barre est retiré (il ne sert pas à la ventilation des quantités), la piste du
				     numéro de ligne tombe à 26 px, et les pistes de saisie sont resserrées de 40 % :
				     86 → 52 px pour les livraisons, 96 → 58 px pour le reste à livrer, abrégé « R.A.L ».
				     Les ~180 px ainsi rendus vont tous à la piste « Produit », la seule élastique. -->
				<!-- Piste de 18 px en tête pour la flèche installation / reprise, sur une commande de location seulement. -->
				@let withDir = hasRentalDirection;
				<div class="grid" [style.grid-template-columns]="(withDir ? '18px ' : '') + '26px 56px minmax(0,1fr) 70px 62px repeat('
						+ (order.lnk_deliveries?.length || 1) + ', minmax(0,52px)) 58px'">

					<div class="row head">
						@if (withDir) { <div class="c c-dir"></div> }
						<div class="c c-seq">#</div>
						<div class="c">Id</div>
						<div class="c">Produit — Unité de vente</div>
						<div class="c c-num">Colisage</div>
						<div class="c c-num">Qté cde</div>
						@for (delivery of order.lnk_deliveries; track delivery.id) {
							<div class="c c-liv" [class.active]="delivery_index === $index" [class.signed]="isDelivered(delivery)" [class.cancel]="isCancel(delivery)"
								 (click)="onChangeIndex($index)">@if (isCancel(delivery)) { Annul. } @else { Liv. {{ $index + 1 }} }
								@if (isDelivered(delivery)) {
									<span class="sub">{{ delivery.realdatdel | tzdate: 'DD/MM HH:mm' }}</span>
								} @else if (delivery_index === $index) {
									<span class="sub">en saisie</span>
								}
							</div>
						}
						<div class="c c-num" matTooltip="Reste à livrer">R.A.L</div>
					</div>

					@for (line of order.lines; track line.id) {
						<div class="row" [class.reprise]="isReprise(line)">
							@if (withDir) { <div class="c c-dir"><app-rental-direction [typ]="line.typ" [qty]="line.qty"></app-rental-direction></div> }
							<div class="c c-seq">{{ line.seq }}</div>
							<div class="c c-id">{{ line.product }}</div>
							<div class="c c-prod">
								<span class="prod-name">
									<a [routerLink]="['/sales/product', line.product]" target="_blank" tabindex="-1"
									   [matTooltip]="lineTitle(line)">{{ lineTitle(line) }}</a>
									@if (lineArticle(line); as a) { <small class="article" [matTooltip]="a">{{ a }}</small> }
								</span>
								@if (line.packaging_name) { <em>— {{ line.packaging_name }}</em> }
							</div>
							<div class="c c-num">{{ line.packaging_qtybaseuom }}</div>
							<div class="c c-num">{{ line.qty }}</div>
							@for (delivery of order.lnk_deliveries; track delivery.id) {
								<div class="c c-liv" [class.active]="delivery_index === $index" [class.signed]="isDelivered(delivery)" [class.cancel]="isCancel(delivery)"
									 (click)="delivery_index === $index ? null : onChangeIndex($index)">
									@if (delivery_index === $index && !isDelivered(delivery)) {
										<input class="qty" type="number" [attr.min]="isRentalLine(line) ? null : 0" onfocus="this.select()"
											[ngModel]="qtiesmap?.get(line.id)?.qties![$index]" (blur)="onQtyBlur(line, $event)">
									} @else {
										{{ qtiesmap?.get(line.id)?.qties![$index] }}
									}
								</div>
							}
							<div class="c c-rest" [class.due]="(qtiesmap?.get(line.id)?.undelivered_qty ?? 0) > 0">{{ qtiesmap?.get(line.id)?.undelivered_qty }}</div>
						</div>
					}
				</div>
				<!-- Le filet de pied de tableau : c'est lui qui referme les lignes. -->
				<div class="tbl-end"></div>
			</div>

			<!-- ─── Bande « sur quel bon » ────────────────────────────────────────────────
			     Plus d'intitulé « Livraisons » : les onglets se nomment eux-mêmes. Le bouton
			     d'ajout descend donc sur leur ligne, dans leur continuité, poussé à droite
			     par le ressort. Une bande de 28 px au lieu de trois rangées. -->
			<div class="blk livs">
				<div class="livtabs">
					@for (delivery of order.lnk_deliveries; track delivery.id) {
						<button type="button" class="livtab" [class.active]="delivery_index === $index"
								[class.signed]="isDelivered(delivery)" [class.cancel]="isCancel(delivery)" (click)="onChangeIndex($index)">
							@if (isDelivered(delivery)) { <mat-icon>{{ isCancel(delivery) ? 'block' : 'lock' }}</mat-icon> }
							<span>@if (isCancel(delivery)) { Annulation } @else { Livraison {{ $index + 1 }} }</span>
							@if (isDelivered(delivery)) { <span class="when">{{ delivery.realdatdel | tzdate: 'DD/MM HH:mm' }}</span> }
							<span class="icon-btn danger" [class.disabled]="isDelivered(delivery)"
								  [matTooltip]="isCancel(delivery) ? 'Bon d\'annulation — définitif' : isDelivered(delivery) ? 'Livraison signée — suppression impossible' : 'Supprimer cette livraison'"
								  (click)="$event.stopPropagation(); onDeleteDelivery($index)"><mat-icon>delete</mat-icon></span>
						</button>
					}
					<span class="grow"></span>
					<button type="button" class="btn add" (click)="saveAndAddDelivery()"><mat-icon>add</mat-icon>Ajouter une livraison</button>
				</div>
			</div>

			<!-- ─── Bande « quand » : la planification ────────────────────────────────────
			     Plus d'intitulé « Planification » : la bande se lit d'elle-même, et la ligne
			     gagnée va au tableau. Cinq rangées à hauteur RÉSERVÉE (voir le SCSS) : les
			     réglages, les deux précisions, le verdict, puis la consigne et le temps sur
			     place. Les pièces jointes ne sont PAS ici : elles vont sous la carte. -->
			<div class="blk plan">
				<form [formGroup]="formGroup">
					<!-- #plan : la page lit l'enfant par cette référence — `attachs_images` pour la
					     bande de vignettes de droite, `deliveryId` et `onFileSelected` pour le
					     bouton d'ajout de la ligne d'actions. Rien d'autre ne traverse. -->
					<app-planificationdelivery #plan [locked]="isDelivered(activeDelivery)"
						[loadOrderEventsSubject$]="loadOrderEventsSubject.asObservable()"
						(changed)="onPlanificationChanged()"></app-planificationdelivery>
				</form>
			</div>

			<!-- Pied de colonne : l'ajout de pièce jointe seul, au bord droit (les actes sur le bon sont dans l'en-tête).
			     Le téléversement reste dans l'enfant (#plan), qui tient `lnk_attachs` ; pas grisé sur un BL signé : on annote un bon livré. -->
			<div class="acts">
				@if (activeDelivery?.id) {
					<span class="grow"></span>
					<input #fileInput type="file" hidden (change)="plan.onFileSelected($event)">
					<button type="button" class="btn" (click)="fileInput.click()"
						aria-label="Ajoutez un fichier"><mat-icon>attach_file</mat-icon>Ajoutez un fichier</button>
				}
			</div>
		</section>

		<!-- ═══ COLONNE DE DROITE — LE « OÙ », PUIS LES DOCUMENTS ════════════════════════
		     UN SEUL DÉFILEMENT POUR LES DEUX. La carte et les vignettes sont sœurs dans une
		     colonne qui défile d'un bloc : à la quatrième pièce jointe, on ne fait pas glisser
		     une bande à l'horizontale, on descend dans la colonne — et la carte remonte
		     progressivement sous l'en-tête pour laisser la place aux documents. C'est aussi ce
		     qui se produit sur toute fenêtre trop courte : la carte s'efface avant les fichiers.
		     C'est ce comportement qui impose de rendre le carrousel ICI, et non à sa place
		     d'origine : app-planificationdelivery vit dans la colonne de gauche, une bande de
		     vignettes rendue par lui ne pourrait pas défiler avec la carte. Il n'en rend donc
		     plus — il n'en reste qu'une, ici, qui lit son tableau `attachs_images`.

		     La carte est en 16/9 et À FOND PERDU : 680 px de large — toute la colonne, sans
		     marge — sur 382 de haut. Elle monte jusqu'au filet de l'en-tête et descend jusqu'aux
		     bords de la feuille : plus de blanc autour d'elle, et plus de trait vertical pour la
		     séparer du tableau. Le format large est aussi le bon format pour une adresse : une
		     rue se lit en longueur.
		     Sa hauteur est un LITTÉRAL répété deux fois à dessein : app-mini-map calcule sa
		     mosaïque de tuiles et le centrage du marqueur à partir de son entrée [height]
		     (render() : `H = this.height`), pas de la taille réelle de sa boîte. Les deux
		     valeurs doivent rester égales, sinon il manque une bande de tuiles en bas et
		     l'épingle est décentrée. -->
		<aside class="col-side">
			<div class="map" [style.height.px]="382">
				@if (geo.lat !== null && geo.lng !== null) {
					<app-mini-map [lat]="geo.lat" [lon]="geo.lng" [height]="382" [label]="adr_delivery"
						(coordsChange)="onMapCoords($event)"></app-mini-map>
				} @else if (geo.status === 'introuvable') {
					<div class="geo-miss"><mat-icon>wrong_location</mat-icon><span>Adresse non
						géolocalisable — complétez l'adresse du client (N° et rue, code postal, ville).</span></div>
				}
			</div>
			@if (geo.dirty) {
				<div class="geo-hint" matTooltip="Coordonnées GPS calculées automatiquement — elles seront
					enregistrées sur l'adresse du client à la sauvegarde de la livraison.">
					<mat-icon>my_location</mat-icon><span>Coordonnées GPS calculées — enregistrées à la sauvegarde</span></div>
			}
			<!-- Géocodage non franc : on montre le libellé RETENU PAR LA BAN, pas seulement le point.
			     C'est ce qui manquait : rien n'avait jamais dit que « 9 CH DE LA CHAPELLE QUARTIER »
			     avait été résolu en « Allée de la Clairière ». Position affichée, jamais enregistrée
			     d'office : l'utilisateur déplace le pin s'il faut, ce qui la rend enregistrable. -->
			@if (geo.doubt) {
				<div class="geo-doubt" matTooltip="Position approximative : elle n'est pas enregistrée sur la
					fiche client. Déplacez le pin sur la carte pour la corriger et l'enregistrer.">
					<mat-icon>help_outline</mat-icon>
					<span>Position approchée — <b>{{ geo.doubt.label }}</b> — non enregistrée</span></div>
			}

			<!-- Une colonne vide ne dit pas d'elle-même qu'elle est vide : sous la carte, l'absence
			     de vignettes ressemblait à un chargement qui n'a pas abouti. La mention prend la
			     place qu'occuperaient les documents et s'y centre — grise, sans cadre, sans icône
			     d'alerte : n'avoir joint aucun fichier est un état normal, pas un avertissement. -->
			@if (plan.attachs_images.length) {
				<app-image-carousel class="docs" [attachs]="plan.attachs_images"></app-image-carousel>
			} @else {
				<div class="docs-empty"><mat-icon>attach_file</mat-icon><span>Aucune pièce jointe</span></div>
			}
		</aside>
	</div>

</div>
}
